import { ReportBlockItem } from './_models'

/**
 * Canonical display order of report status cards.
 * The API returns status blocks in an arbitrary order (it depends on the data),
 * so every report page must sort them through `sortReportBlocks` before rendering.
 */
export const REPORT_BLOCK_STATUS_ORDER: Array<ReportBlockItem['status']> = [
  'ACTIVE',
  'IN_PROGRESS',
  'COMPLETED',
  'DECLINED',
  'EXPIRED',
]

const statusRank = (status: ReportBlockItem['status']): number => {
  const index = REPORT_BLOCK_STATUS_ORDER.indexOf(status)

  return index === -1 ? REPORT_BLOCK_STATUS_ORDER.length : index
}

export const sortReportBlocks = <T extends Pick<ReportBlockItem, 'status'>>(blocks: T[]): T[] =>
  [...blocks].sort((block1, block2) => statusRank(block1.status) - statusRank(block2.status))
